import { useCallback } from 'react';
import { useApi } from './useApi';

const PAGE_STYLE = 'font-family:sans-serif;max-width:40em;margin:4em auto;padding:0 1em;';

function showMessage(tab, title, body) {
  tab.document.title = title;
  tab.document.body.innerHTML = `<div style="${PAGE_STYLE}"><h1>${title}</h1><p>${body}</p></div>`;
}

export function useOpenDocument() {
  const { fetchAPI } = useApi();

  return useCallback(async (doc) => {
    // Opened synchronously in the click handler so popup blockers allow it; filled in after the fetch.
    const tab = window.open('', '_blank');
    if (!tab) throw new Error('Popup blocked: could not open document tab');
    tab.opener = null;
    try {
      const { url } = await fetchAPI(`/api/documents/${doc.orgId}/${doc.id}/download`);
      tab.location.href = url;
    } catch (err) {
      if (err.status === 404) {
        showMessage(tab, 'Document unavailable', 'This document is no longer available in the library. '
          + 'It may have been removed or replaced.');
        return;
      }
      console.error('[useOpenDocument] Failed to open document', doc.id, err);
      showMessage(tab, 'Could not open document', 'Something went wrong opening this document. Please try again.');
    }
  }, [fetchAPI]);
}
